import type { FieldErrors } from 'react-hook-form/dist/types/errors';

export const ErrorAssembler = {
  toErrorKeys: (errors: FieldErrors | undefined) => {
    return errors
      ? Object.entries(errors).reduce((acc, [e, k]) => {
          if (Array.isArray(k)) {
            const d = k.flatMap((x, i) =>
              Object.entries(x).map(([a, _]) => `${a}.${i}`),
            );
            return [...acc, ...d];
          } else {
            return [...acc, e];
          }
        }, [] as string[])
      : [];
  },
};
